import { useState, useEffect } from 'react'

import { VITE_API_BASE } from '../config/apiConfig'
const API = VITE_API_BASE

export default function StudyBaseApproval() {
  const [activities, setActivities] = useState([])
  const [loading, setLoading] = useState(true)
  const [tab, setTab] = useState('pending') // pending | approved

  useEffect(() => {
    fetchActivities()
  }, [tab])

  const fetchActivities = async () => {
    setLoading(true)
    try {
      const url = tab === 'pending' 
        ? `${API}/base-activities/cms/pending`
        : `${API}/base-activities/cms/approved`
      const res = await fetch(url)
      const data = await res.json()
      setActivities(data.data || [])
    } catch (e) {
      console.error('获取活动失败', e)
    }
    setLoading(false)
  }

  const handleApprove = async (id) => {
    if (!confirm('确认通过此活动？')) return
    try {
      const res = await fetch(`${API}/base-activities/cms/${id}/approve`, {
        method: 'PUT'
      })
      const data = await res.json()
      if (data.success) {
        alert('审核通过！')
        fetchActivities()
      }
    } catch (e) {
      alert('操作失败')
    }
  }

  const handleReject = async (id) => {
    const reason = prompt('请输入拒绝原因：')
    if (!reason) return
    try {
      const res = await fetch(`${API}/base-activities/cms/${id}/reject`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ reason })
      })
      const data = await res.json()
      if (data.success) {
        alert('已拒绝')
        fetchActivities()
      }
    } catch (e) {
      alert('操作失败')
    }
  }

  const card = {
    background: '#fff',
    borderRadius: 12,
    padding: 24,
    marginBottom: 16,
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
  }

  const btn = {
    padding: '6px 16px',
    border: 'none',
    borderRadius: 6,
    cursor: 'pointer',
    fontSize: 13
  }

  return (
    <div style={{ padding: 24, maxWidth: 1200, margin: '0 auto' }}>
      <h1 style={{ fontSize: 24, marginBottom: 24 }}>🏕️ 基地活动审核</h1>
      
      {/* 标签页 */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 24 }}>
        <button 
          onClick={() => setTab('pending')}
          style={{ 
            ...btn, 
            background: tab === 'pending' ? '#1890ff' : '#f0f0f0',
            color: tab === 'pending' ? '#fff' : '#666'
          }}
        >
          待审核 ({activities.length})
        </button>
        <button 
          onClick={() => setTab('approved')}
          style={{ 
            ...btn, 
            background: tab === 'approved' ? '#52c41a' : '#f0f0f0',
            color: tab === 'approved' ? '#fff' : '#666'
          }}
        >
          已通过
        </button>
      </div>

      {/* 活动列表 */}
      {loading ? (
        <div style={{ textAlign: 'center', padding: 40 }}>加载中...</div>
      ) : activities.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 40, color: '#999' }}>
          暂无{tab === 'pending' ? '待审核' : ''}活动
        </div>
      ) : (
        activities.map(a => (
          <div key={a.id} style={card}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <h3 style={{ fontSize: 18, marginBottom: 8 }}>{a.title || a.name}</h3>
                <div style={{ color: '#666', fontSize: 14, display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '8px 24px' }}>
                  <div>基地：{a.base_name || a.baseName || '-'}</div>
                  <div>地点：{a.location || '-'}</div>
                  <div>日期：{a.activity_date || a.date}</div>
                  <div>价格：¥{a.price || 0}</div>
                  <div>名额：{(a.max_participants || a.maxParticipants || 30)}人</div>
                  <div>状态：<span style={{ color: a.status === 'active' ? '#52c41a' : '#faad14' }}>{a.status === 'active' ? '已发布' : a.status}</span></div>
                </div>
                {a.description && (
                  <p style={{ marginTop: 12, color: '#666', fontSize: 14 }}>{a.description}</p>
                )}
              </div>
              {tab === 'pending' && (
                <div style={{ display: 'flex', gap: 8 }}>
                  <button 
                    onClick={() => handleApprove(a.id)}
                    style={{ ...btn, background: '#52c41a', color: '#fff' }}
                  >
                    ✅ 通过
                  </button>
                  <button 
                    onClick={() => handleReject(a.id)}
                    style={{ ...btn, background: '#ff4d4f', color: '#fff' }}
                  >
                    ❌ 拒绝
                  </button>
                </div>
              )}
            </div>
          </div>
        ))
      )}
    </div>
  )
}
